let _store;

export const injectStore = (store) => {
  _store = store;
};

export const getStore = () => {
  return _store;
};
